import { Link } from '@material-ui/core';
import { navigateBookDemoClick } from 'common/utils/utils';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import { isTeamSynced as getIsTeamSynced } from 'state/selectors/teams';

const maxMembers = ({ team, max, members }) => {
  const { length: membersCount } = members || [];
  const isTeamSynced = getIsTeamSynced(team);
  const hasMaxContributors = !!max && membersCount === max;

  return (
    <Flex direction='column'>
      {max && !isTeamSynced && (
        <Text size='medium'>
          {membersCount}/{max} {hasMaxContributors ? 'max' : ''} members
          selected
        </Text>
      )}
      {hasMaxContributors && !isTeamSynced && (
        <Flex pt='tiny'>
          <Text>Want to add more team members? </Text>&nbsp;
          <Link onClick={navigateBookDemoClick}>upgrade your account</Link>
        </Flex>
      )}
    </Flex>
  );
};

export default maxMembers;
